import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MobileAppComponent } from './mobile-app/mobile-app.component';

@Component({
  selector: 'app-application-mobile',
  standalone: true,
  imports: [MobileAppComponent, TranslatePipe],
  templateUrl: './application-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./application-mobile.component.scss'],
})
export class ApplicationMobileComponent {}
